<div class="w-full h-full">
  <canvas
    id="timeReportPanelChart"
    class="h-full w-full"
  ></canvas>
</div>
